module.exports = __webpack_public_path__ + "static/media/mobile-andarbahar.b19f1979.svg";